import TS from './DictSelect.vue';
import Dict from './Dict.vue';

// 获取字典表接口
import store from '@/store';

const DictSelect = {
  install: function(Vue) {
    Vue.component('DictSelect', TS);
    Vue.component('Dict', Dict);

    // 获取某个字典项
    Vue.prototype.$getDictionary = function(code, value) {
      return new Promise((resolve, reject) => {
        store.dispatch('getDictItemsByCode', code)
          .then((res) => {
            resolve(res);
          });
      });
    };
  }
};
export default DictSelect;



// WEBPACK FOOTER //
// ./src/libs/dictSelect/index.js